import { useCallback } from 'react';
import { useAuth } from '../contexts/auth-context';
import { useStorage } from './useStorage';
import { orchestrator } from '../websocket/orchestrator';
import { storage } from '../websocket/storage';
import { ExportType } from '../types/export.types';
import {
  ExportProgressData,
  EXPORT_TYPE_TO_ROUTE,
  buildExportKey,
} from '../websocket/domains/export/export.types';

export interface ExportProgressResult {
  data: ExportProgressData | null;
  start: (hasFilters?: boolean) => void;
}

export function useExportProgress(type: ExportType, analysisId?: string | number): ExportProgressResult {
  const { user } = useAuth();

  const domainId = type === ExportType.EXPORT_ANALYSIS
    ? (analysisId ?? 0)
    : (user?.id ?? 0);

  const storageKey = buildExportKey(type, domainId);
  const data = useStorage<ExportProgressData>(storageKey);

  const start = useCallback(
    (hasFilters?: boolean) => {
      const route = EXPORT_TYPE_TO_ROUTE[type];
      const numericId = parseInt(domainId.toString(), 10);

      if (!numericId || isNaN(numericId)) return;

      storage.set<ExportProgressData>(storageKey, {
        status: 'WAITING',
        exportType: type,
        domainId: domainId.toString(),
        hasFilters: hasFilters ?? false,
      });

      orchestrator.addConnection({ route, storageKey, id: numericId });
    },
    [type, domainId, storageKey],
  );

  return { data, start };
}
